import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { SharedAlertModalComponent } from './alert-modal.component';
import { SharedConfirmationModalComponent } from './confirmation-modal.component';
import { SharedWarningModalComponent } from './warning-modal.component';

@NgModule({
    declarations: [
        SharedAlertModalComponent,
        SharedConfirmationModalComponent,
        SharedWarningModalComponent
    ],
    imports: [
        CommonModule,
        MatDialogModule
    ]
})
export class SharedComponentsModalModule {
}
